/* Keep the product blocks in order; the fitment app owns its own UI. */
(() => {
  if (window.rivalProductOrderReady) return;
  window.rivalProductOrderReady = true;
  const order = () => {
    document.querySelectorAll('.rival-product-page [data-rival-product-compatibility]').forEach(card => {
      const block = card.closest('.product__block');
      const info = card.closest('[id^="ProductInfo-"]');
      if (!block || !info) return;
      const title = info.querySelector('.product__block--title');
      const meta = info.querySelector('.product__block--meta');
      if (title && meta && title.nextElementSibling !== meta) title.after(meta);
      const stock = info.querySelector('rival-stock-label')?.closest('.product__block');
      if (stock && stock.nextElementSibling !== block) stock.after(block);
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; order(); });
  }).observe(document.body, { childList: true, subtree: true });
  order();
})();
